import { COLORS } from 'helpers/globals'

const handleStyle = {
  position: 'absolute',
  marginLeft: -7,
  marginTop: -8,
  width: '4rem',
  height: '1.9rem',
  cursor: 'pointer',
  borderRadius: 5,
  border: `solid 1px ${COLORS.primary}`,
  backgroundColor: '#fff',
  lineHeight: '1.9rem',
  fontSize: '1.2rem',
  textAlign: 'center',
  color: 'black'
}

export { handleStyle }

const column = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%'
}

const button = {
  color: 'white',
  background: COLORS.primary,
  fontWeight: 400,
  textAlign: 'center',
  padding: '.5rem 2rem',
  borderRadius: '1rem',
  cursor: 'pointer'
}

export default {
  column,
  form: {
    ...column,
    width: '100%',
    marginBottom: '1rem'
  },
  fileInput: {
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1
  },
  fileInputLabel: {
    ...button,
    '&:hover': {
      background: COLORS.primaryHover
    }
  },
  sliderContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    marginTop: '.5rem',
    touchAction: 'none',
    width: '100%'
  },
  slider: {
    margin: '0 1rem 0 2.5rem'
  },
  submitFormButton: {
    ...button,
    background: '#009e25',
    '&:hover': {
      background: '#008e21'
    }
  },
  submitFormButtonDisabled: {
    ...button,
    cursor: 'not-allowed',
    background: COLORS.secondary
  },
  loadingIcon: {
    fontSize: '1.8rem'
  },
  errorMessage: {
    paddingTop: '2rem',
    color: COLORS.danger,
    textAlign: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovUploadsForm/style.js